var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("patient-panel.foods")))])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "neu-cards-ctn landing-cnt  mt-5",
          attrs: { cols: "1", "cols-xl": "4" }
        },
        [
          _c("PatientPanelServiceBlock", {
            attrs: {
              id: "food-healthy",
              visible: "",
              title: _vm.$t("patient-panel.caring-foods"),
              action: function() {
                _vm.$router.push("/patient/foods")
              },
              img:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/fruit.svg"
            }
          }),
          _vm._v(" "),
          _c("PatientPanelServiceBlock", {
            attrs: {
              id: "wellwo",
              visible: _vm.wellwoVisible,
              action: function() {
                _vm.goToWellwo("nut")
              },
              title: _vm.$t("patient-panel.diets-recipes"),
              img:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/healthy-diets-and-food-recipes.svg"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c7e1498", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c7e1498","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/HealthyFoodPanelMenu.vue
// module id = 4189
// module chunks = 86